<template>
    <div id="EnSupplyChainCompanies">
        <h1 class="h1 w90-mb">{{ title }}</h1>
        <div v-if="item === null" class="no-company">No Partner</div>
        <div v-else>
            <section class="company-info">
                <div class="img-wrap">
                    <img
                        :src="item.company.logoUrl"
                        :alt="item.company.name + 'Logo'"
                    />
                </div>
                <h3>{{ item.company.name }}</h3>
                <ul class="table">
                    <li>
                        <span class="head">Contract person</span>
                        <span class="body">
                            {{
                                item.contact.name +
                                '\n' +
                                item.contact.phone +
                                '\n' +
                                item.contact.email
                            }}
                        </span>
                    </li>
                    <li v-if="item.recycle && item.recycle.types">
                        <span class="head">Material of processing</span>
                        <span class="body">
                            {{ item.recycle.types.join(', ') }}
                        </span>
                    </li>
                    <li v-if="item.recycle && item.recycle.allowedRange">
                        <span class="head">Receiving area</span>
                        <span class="body">{{
                            item.recycle.allowedRange
                        }}</span>
                    </li>
                    <!-- <li v-if="item.recycle && item.recycle.allowedStandard">
                        <span class="head">允收標準</span>
                        <span class="body">{{
                            item.recycle.allowedStandard
                        }}</span>
                    </li> -->
                    <li v-if="item.product && item.product.types">
                        <span class="head">Product type</span>
                        <span class="body">
                            {{ item.product.types.join('、') }}
                        </span>
                    </li>
                </ul>
            </section>
            <!-- <section class="company-article w90-mb">
                <p
                    class="p1"
                    v-for="(
                        paragraph, subindex
                    ) in item.company.introduction.split('\n')"
                    :key="item.company.name + '-' + subindex"
                >
                    {{ paragraph }}
                </p>
            </section> -->
            <section class="other-companies w90-mb">
                <h2 class="h2">Other {{ title }}</h2>
                <ul>
                    <li
                        v-for="(company, index) in supplyChainData[type]"
                        :key="type + '-company-' + index"
                        :class="{
                            active:
                                company.company.companyId ==
                                route.params.companyId,
                        }"
                        @keypress.enter="
                            changeCompany(company.company.companyId)
                        "
                        @click="changeCompany(company.company.companyId)"
                        tabindex="0"
                        role="button"
                    >
                        <img
                            :src="company.company.logoUrl"
                            :alt="company.company.name + 'Logo'"
                        />
                    </li>
                </ul>
            </section>
        </div>
    </div>
</template>
<script>
import { onBeforeRouteUpdate, useRoute, useRouter } from 'vue-router'
import getEnSupplyChainCompanies from '@/data/getEnSupplyChainCompanies'
import { computed, ref } from 'vue-demi'
export default {
    name: 'EnSupplyChainCompanies',
    setup() {
        const router = useRouter()
        const route = useRoute()
        const type = ref(route.params.type)
        const companyId = ref(route.params.companyId)
        const { supplyChainData } = getEnSupplyChainCompanies()
        let item = ref({})

        const title = computed(() => {
            if (type.value === 'brand') return 'Brand Industry Partners'
            else if (type.value === 'recycle')
                return 'Recycling Industry Partners'
            else
                return 'Waste Disposal Industry / Manufacturing Industry Partners'
        })
        function changeCompany(index) {
            router.push({
                name: 'EnSupplyChainCompanies',
                params: {
                    type: type.value,
                    companyId: index,
                },
            })
        }
        function initItem() {
            function getItem(item) {
                return item.company.companyId == companyId.value
            }
            if (supplyChainData[type.value].length === 0) item.value = null
            else item.value = supplyChainData[type.value].find(getItem)
        }

        initItem()
        onBeforeRouteUpdate((to, from, next) => {
            type.value = to.params.type
            companyId.value = to.params.companyId
            initItem()
            window.scroll({
                top: 0,
                left: 0,
            })
            next()
        })

        return {
            supplyChainData,
            type,
            companyId,
            title,
            item,
            changeCompany,
            route,
        }
    },
}
</script>
<style lang="scss" scoped>
.no-company {
    text-align: center;
    color: $grayB;
    font-size: 20px;
    font-weight: 900;
    margin: 20px 0 80px;
}
.company-info {
    background-color: $grayF;
    padding: 50px 30px 30px;
    .img-wrap {
        margin: 0 auto;
        width: 240px;
        height: 240px;
        border-radius: 50%;
        background-color: $white;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
            position: relative;
            top: 2%;
            max-width: 80%;
            max-height: 80%;
        }
    }
    h3 {
        margin: 30px 0;
        color: $gray6;
        text-align: center;
        font-size: 28px;
        font-weight: 700;
        line-height: 1.5em;
        letter-spacing: 0.05em;
    }
}
.company-article {
    margin: 30px auto;
}
.other-companies {
    padding-top: 50px;
    ul {
        display: flex;
        flex-wrap: wrap;
        margin: 20px 0 50px;
    }
    li {
        margin: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100px;
        height: 100px;
        border-radius: 50%;
        box-shadow: $shadow1;
        cursor: pointer;

        &.active {
            border: 3px solid $theme3;
            cursor: default;
        }
    }
    img {
        max-width: 80%;
        max-height: 80%;
    }
}
</style>
